import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import MyDatePicker from "../widgets/DatePicker";
import SelectInput from "../widgets/SelectInput";
import moment from "moment";
import getImpostazioni from "../services/getImpostazioni";
import getSpesa from "../services/getSpesa";
import editSpesa from "../services/editSpesa";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class EditSpesa extends React.Component {
    constructor(props){
        super (props)

        this.fatturaDateRef = React.createRef();

        this.disposizioni = [
            { value: 0, label: 'Immediato' },
            { value: 30, label: '30 GG.DF.FM.' },
            { value: 60, label: '60 GG.DF.FM.' },
            { value: 90, label: '90 GG.DF.FM.' },
            { value: 120, label: '120 GG.DF.FM.' },
            { value: 150, label: '150 GG.DF.FM.' },
            { value: 180, label: '180 GG.DF.FM.' },
        ];

        this.tipiDocumenti = [
            { value: 0, label: 'Non definito' },
            { value: 1, label: 'Fattura' },
            { value: 2, label: 'Fattura differita di cui l’art. 21, comma 4, lett. a' },
            { value: 3, label: 'Nota di Credito' },
            { value: 4, label: 'Acconto/Anticipo su Fattura' }
        ];

        this.tags = [];
        this.metodiPagamento = [];

        this.state = {
            descrizione: '',
            dataFattura: undefined, 
            importo: '', 
            tag: { value: undefined, label: '' }, 
            metodoPagamento: { value: undefined, label: '' }
        };

    }

    async componentDidMount() {

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
    
        let current = cookies.get('spesa', { path: '/' });
        let fattura = await getSpesa(username, token, current);
        let impostazioni = await getImpostazioni(username, token);

        this.tags = impostazioni.find(i => i.tipo === 'anagrafiche');
        this.tags = JSON.parse(this.tags.payload);
        this.tags.forEach((t, i) => {
            this.tags[i] = { value: parseInt(t.scarico), label: t.label }
        });

        this.tags = [{ value: 100, label: ""}, ...this.tags];

        this.metodiPagamento = impostazioni.find(i => i.tipo === 'pagamenti');
        this.metodiPagamento = JSON.parse(this.metodiPagamento.payload);
        this.metodiPagamento.forEach((t, i) => {
            this.metodiPagamento[i] = { value: t.label, label: t.label }
        });

        this.metodiPagamento = [{ value: "", label: ""}, ...this.metodiPagamento];
        
        this.setState({
            descrizione: fattura.descrizione, 
            importo: fattura.importo, 
            dataFattura: moment(fattura.data, 'DD/MM/yyyy').toDate(), 
            tag: { value: 0, label: fattura.tag }, 
            metodoPagamento: { value: fattura.pagamento, label: fattura.pagamento }
        });
    }

    render () {

        return (
        <>
            <PageTitle title={'Modifica spesa'} />

            <div style={{ display: 'flex', marginLeft: 3 }}>
                {this.state.metodoPagamento.label !== '' && (
                    <div style={{ backgroundColor: '#B6EEB8', boxShadow: '0px 1px 2px white', borderRadius: 5, marginTop: -25, marginBottom: 25, marginRight: 10 }}>
                        <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 10, marginRight: 10 }}>{this.state.metodoPagamento.label}</p>
                    </div>
                )}
                {this.state.tag.label !== '' && (
                    <div style={{ backgroundColor: '#CED86B', boxShadow: '0px 1px 2px white', borderRadius: 5, marginTop: -25, marginBottom: 25 }}>
                        <p style={{ marginTop: 3, marginBottom: 3, marginLeft: 10, marginRight: 10 }}>{this.state.tag.label}</p>
                    </div>
                )}
            </div>

            <SelectInput
                key={Math.random()}
                value={this.state.tag} 
                name={"Tag"} 
                options={this.tags} 
                onChange={(option) => {
                    this.setState({ tag: option });
                }}
            />

            <TextInput name={'Descrizione'} value={this.state.descrizione} 
                onChange={(text) => { this.setState({descrizione: text})}
            } />

            <MyDatePicker ref={this.fatturaDateRef} name={'Data spesa'} value={this.state.dataFattura} />

            <div style={{ height: 30 }}></div>


            <TextInput noState={true} name={'Importo'} value={this.state.importo}
                onChange={(text) => {
                    var t = text.replace(/\./g, '');
                    if(/[^0-9,]+/.test(t)) {
                        t = t.replace(/[^0-9]+/g, '');
                    }
                    var chunks = t.split(',');
                    chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    t = chunks.join(',');
                    this.setState({importo: t.trim()});
                }}
            />

            <SelectInput
                key={Math.random()}
                value={this.state.metodoPagamento} 
                name={"Metodo di pagamento"} 
                options={this.metodiPagamento} 
                onChange={(option) => {
                    this.setState({ metodoPagamento: option });
                }}
            />

            <div style={{ height: 30 }}></div>
            <FixButton title={'Salva'} callback={() => this.save()} />
        </>
        );
    }

    async save() {

        this.setState({ isLoading: true });

        if (!this.state.descrizione) {
            alert('Inserire una descrizione');
            return;
        }

        if (!this.state.importo) {
            alert('Inserire un importo per la fattura');
            return;
        }

        var date = this.fatturaDateRef.current.getDate();

        if (moment(date).isAfter(moment())) {
            alert('Non è possibile impostare una data successiva a quella di oggi.')
            return;
        }

        date = moment(date).format('DD/MM/yyyy');

        let uscita = {
            id: cookies.get('spesa', { path: '/' }),
            descrizione: this.state.descrizione, 
            data: date, 
            importo: this.state.importo, 
            tag: this.state.tag.label, 
            pagamento: this.state.metodoPagamento ? this.state.metodoPagamento.label : '', 
        };

        let res = await editSpesa(username, token, uscita);
        if (res.result === 'ok') {
            window.location.href = '/#/app/fatture';
            return;
        }
        
        this.setState({ isLoading: false });
        alert('Si è verificato un errore inatteso. Per favore, riprova.');
    }

}

